<div class="modify-session-header">
  <mmx-balance-status-chip *ngIf="status" [status]="status"></mmx-balance-status-chip>
  <span *ngIf="isModifying" class="modifying-pill" data-testid="modifying-pill">
    {{ 'balance.modify-session.modifying' | translate }}
  </span>
</div>
